<template>
  <div class="linked-card" v-if="show">
    <router-link :to="link_simcard()" class="link">
      <div class="linked-card_header">
        <span class="linked-card_header_name">{{title}}</span>
      </div>

      <div class="linked-card_footer">
        <span :class="'mdi ' + icon"></span>
      </div>
    </router-link>
  </div>
</template>

<script>

export default {
  name: "LinkedSimCard",
  props: ['title', 'simcard'],
  data () {
    return {
    }
  },
  computed:{
    icon(){
      return this.title === 'esim_profile' ? 'mdi-card-bulleted' : this.title === 'simcard_profile' ? 'mdi-sim' : 'mdi-sim-outline'
    },
    show(){
      if (this.title === 'esim_profile' && (this.$store.getters.getPermissions?.viewSimcardProfile === true)){
        return true
      }
      if (this.title === 'simcard_profile' && (this.$store.getters.getPermissions?.viewSimcardProfile === true)){
        return true
      }
      return this.title === 'device_simcard';
    }
  },
  methods: {
    link_simcard(){
      let index = this.simcard.imsi && String(this.simcard.imsi).length > 14 ? this.simcard.imsi : this.simcard.id
      switch (this.title) {
        case 'esim_profile': return {path: '/esim_profile/' + this.simcard.id}
        case 'simcard_profile': return {path: '/simcard_profile/' + index}
        case 'device_simcard': return {path: '/simcard_devices/' + index}
      }
    }
  },
}
</script>

<style lang="scss" scoped>

  .linked-card {
    border-radius: 10px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    padding-bottom: 0;
    position: relative;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
    height: 100%;
    &_header {
      font: 300 12px/16px "Roboto", Arial, sans-serif;
      // text-transform: uppercase;
      color: #000;
      background: #f4f3ef;
      padding: 5px 10px;
      border-radius: 10px 10px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &_footer {
      padding: 5px 0 0;
      border-top: 1px solid #ccc;
      height: 70%;
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        font-size: 36px;
      }
    }
  }

  @media (max-width: 475px) {
    .linked-card {
      &_content {
        .content-item{
          flex-wrap: wrap;
          .left{
            width: 100%;
          }
          .right{
            width: 100%;
          }
        }
      }
    }
  }


</style>
